var render = function render(){var _vm=this,_c=_vm._self._c;return _c('exfoliants-template',{attrs:{"tolerates-exfoliant-actives":_vm.toleratesExfoliantActives,"use-other-exfoliants":_vm.useOtherExfoliants,"is-use-other-exfoliants-visible":_vm.isUseOtherExfoliantsVisible,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }